import api, { handleApiResponse } from './api';
import { ApiResponse, WorkCategory } from '../types';

export const workCategoryService = {
  // Obtener todos los rubros
  async getAllWorkCategories(): Promise<WorkCategory[]> {
    const response = await api.get<ApiResponse<WorkCategory[]>>(
      'settings/work-categories',
    );
    return handleApiResponse(response);
  },

  // Crear un nuevo rubro
  async createWorkCategory(
    value: string,
    description: string,
  ): Promise<WorkCategory> {
    const response = await api.post<ApiResponse<WorkCategory>>(
      'settings/work-category',
      { value, description },
    );
    return handleApiResponse(response);
  },

  //Actualizar rubro

  async updateWorkCategory(
    id: number,
    value: string,
    description: string,
  ): Promise<WorkCategory> {
    const response = await api.put<ApiResponse<WorkCategory>>(
      `settings/work-category/${id}`,
      { value, description },
    );
    return handleApiResponse(response);
  },

  async deleteWorkCategory(id: number): Promise<void> {
    await api.delete('settings/work-category', { params: { id } });
  },
};

export default workCategoryService;
